import { useAuthorization } from "@sttedra_ui/framework";

import ReportsView from "../reports/ReportsView.vue";

export default [
  {
    path: "/admin/Reports",
    name: "Reports",
    component: ReportsView,
    meta: {
      title: "Informes",
      requiresAuthentication: false,
    },
    beforeEnter: async (to, from, next) => {
      localStorage.setItem("layout", "admin");

      const { modelRef: authorizationModelRef } = useAuthorization();

      const userRol = authorizationModelRef.value.roles[0];

      if (userRol != "Admin") {
        next({ name: "Login" });
      }

      next();
    },
  },
];
